import { useRecoilRefresher_UNSTABLE, useRecoilValueLoadable } from 'recoil'
import { MutualFundsSIPs } from '../../store/MFStore'
import { useEffect } from 'react'
import SipTable from '../../Components/MutualFunds/SipTable'
import MFOrdersSkeleton from '../../Components/SkeletonLoaders/MFOrdersSkeleton'
import PostHogTracker from '../../utils/PostHogTracker'
import SIPsEmpty from '../../Components/EmptyState/SIPsEmpty'
import ApiErrorState from '../../Components/Errors/ApiErrorState'

const MFSips = () => {
  const sips = useRecoilValueLoadable(MutualFundsSIPs)
  const refreshSIPs = useRecoilRefresher_UNSTABLE(MutualFundsSIPs)

  useEffect(() => {
    refreshSIPs()
    // Track SIPs tab clicked
    PostHogTracker.sipsTabClicked()
    PostHogTracker.pageViewed('Active SIPs')
  }, [])

  if (sips.contents.length === 0) {
    return (
      <div className='fabits-dark-section flex items-center justify-center bg-white'>
        <ApiErrorState />
      </div>
    )
  }

  switch (sips.state) {
    case 'loading':
      return (
        <div className='max-w-[1128px] mx-auto'>
          <MFOrdersSkeleton />
        </div>
      )

    case 'hasValue':
      return (
        <div className='fabits-dark-section min-h-screen bg-white'>
          {sips?.contents?.message?.toLowerCase() === 'no sip found for the specified user.' ? (
            <SIPsEmpty
              title='It seems you have no SIPs'
              description='Get started with investing today. You can either invest in a plan or explore our custom funds.'
              mainText='SIPs'
              page='/dashboard/mutual-funds'
              showButton={false}
              variant='active'
            />
          ) : (
            <div className='max-w-[1128px] mx-auto'>
              <SipTable sips={sips?.contents?.data} />
            </div>
          )}
        </div>
      )

    case 'hasError':
      return (
        <div className='fabits-dark-section flex items-center justify-center bg-white'>
          <ApiErrorState />
        </div>
      )

    default:
      return null
  }
}

export default MFSips
